import { TableField } from "../../table-field";

const nome: TableField = {
    key: "NOME",
    label: "Nome",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const CPF: TableField = {
    key: "CPF",
    label: "CPF",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const email: TableField = {
    key: "EMAIL",
    label: "E-mail",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const situacao: TableField = {
    key: "SITUACAO",
    label: "Situação",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const actions = {
    key: "acao",
    label: "",
    tdClass: ["align-middle", "col-actions"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};

export const fieldsNovosUsuarios: TableField[] = [
    nome,
    CPF,
    email,
    situacao,
    actions,
];
